export const NEW = 'new';
export const FAIL = 'fail';
export const MIXED = 'mixed';
